import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Divider, Grid, Backdrop } from "@mui/material";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import DonutChart from "../../components/donutchart";
import { useNavigate, useParams } from "react-router-dom";
import DocumentTable from "../../components/DocumentTable";
import { CaseOverview } from "../../functions/apicall";
import TagSVG from '../../assets/media/Icon_tag.svg';
import {get, isEmpty} from 'lodash';
import moment from "moment";
import Box from "../../components/base/Box";

const CaseDetails = (props) => {
  const { id } = useParams();
  const [caseData, setCaseData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [ docLoading, setDocLoading ] = useState(true);
  const [ tags, setTags ] = useState(null);
  const [caseLoad, setCaseLoad] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [ pageSize, setPageSize ] = useState(5);
  const [page, setPage] = useState(1);
  const [ totalPages, setTotalPages ] = useState(null);
  const [filters, setFilters] = useState({});
  const [totalItems, setTotalItems] = useState({})
  const MINUTE_MS = 10000;

  useEffect(() => {
    localStorage.removeItem('filter');
    localStorage.setItem('filterOpen', "close");
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      if(isEmpty(filters)) {
        fetchCases(null, {}, false);
      } else {
        fetchCases(null, { filter:  filters}, false);
      }
    }, MINUTE_MS);

    return () => clearInterval(interval);
  }, [page, filters])

  useEffect(() => {
    if(isEmpty(filters) || Object.values(filters).every(el => el === null)) {
      fetchCases();
    } else {
      fetchCases(null, { filter:  filters});
    }
  }, [page, pageSize,filters]);

  const fetchCases = async (p_page, filters = {}, isLoadingRequired = true) => {
    if(isLoadingRequired){
      await setDocLoading(true);
      if (rowData) {
        setRowData([]);
      }
    }
    const body = {
      case_id: id,
      ...filters
    };
    const showError = isLoadingRequired
    const case_data = await CaseOverview(
      p_page ? p_page : page,
      pageSize,
      body,
      showError
    );
    if (case_data) {
      setTags(case_data.case_detail.tag.split(','));
      setCaseData(case_data.case_detail);
      setTotalPages(case_data.totalPages);
      setTotalItems(case_data.totalItems);
      const new_file_list = [];
      for (let file of case_data.file_list) {
        let new_obj = { ...file };
        if (new_obj.tags != "") {
          let tagList = new_obj.tags.split(",");
          new_obj.tagList = tagList;
        }
        new_file_list.push(new_obj);
      }
      setRowData(new_file_list);
    }
    setDocLoading(false);
  };

  useEffect(() => {
    if (caseData && tags) {
      setLoading(false);
    }
  }, [caseData, tags]);

  // useEffect(() => {
  //   if (rowData) {
  //     setDocLoading(false);
  //   }
  //   else {
  //     setDocLoading(true);
  //   }
  // }, [rowData]);

  const creationDate = get(caseData,'creation_date') && moment(caseData.creation_date, 'DD/MM/YYYY,hh:mm A').local().format('DD/MM/YYYY,hh:mm A');
  return (
    <>
      {loading ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: '1500' }}
          open={loading}
          // onClick={handleClose}
          //
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Grid container spacing={2} className="maindivpage">
          <Grid md={12} sm={12} xs={12} lg={12}>
            <h2 className="pagehead">Case Overview</h2>
          </Grid>

          <div className="caseCardHolder">
            <div
              className="caseCard1"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <Box fontSize='20px'>Case Details</Box>
              <div style={{ display: "flex", gap: "140px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "40px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div style={{ color: "#402E46", opacity: 0.7, fontSize: '17px' }}>
                      Case Name
                    </div>
                    <div>{caseData.case_name}</div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div style={{ color: "#402E46", opacity: 0.7, fontSize: '17px' }}>
                      Case Type
                    </div>
                    <div>{caseData.case_type}</div>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "40px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div style={{ color: "#402E46", opacity: 0.7, fontSize: '17px' }}>
                      Case Owner
                    </div>
                    <div>{get(caseData, 'owner_info.name', "-") || "-"}</div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div style={{ color: "#402E46", opacity: 0.7, fontSize: '17px' }}>
                      Creation date
                    </div>
                    <div>{creationDate}</div>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", gap: "8px", flexWrap: 'wrap' }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    // gap: "2px",
                    backgroundColor: "#E2E2E2",
                    borderRadius: "10%",
                    paddingRight: '10px'
                  }}
                >
                  {/* <LocalOfferOutlinedIcon /> */}
                  <img src={TagSVG} />
                  #tags
                </div>

                {tags && tags.length > 0 ? (
                  [ tags.map(tag => (
                    [ tag != '' ?
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "#ddeeff",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                          borderRadius: "8px",
                          color: "#402E46",
                        }}
                      >
                        {"#" + tag}
                      </div>
                    : ""]
                  )) ]
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#ddeeff",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      paddingTop: "5px",
                      paddingBottom: "5px",
                      borderRadius: "8px",
                      color: "#402E46",
                    }}
                  >
                    No tags
                  </div>
                )}
              </div>
            </div>

            <div className="caseCard2">
              <Box fontSize='20px'>Case Analytics</Box>
              <Box sx={{display: 'flex', justifyContent: 'space-evenly', marginTop: '5px'}}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ fontSize: "50px" }}>
                    {caseData.total_documents}
                  </div>
                  <div
                    style={{
                      color: "#402E46",
                      opacity: 0.7,
                      width: "80px",
                      textAlign: "center",
                    }}
                  >
                    Total Documents
                  </div>
                </div>

               <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ fontSize: "50px" }}>
                    {caseData.average_words}
                  </div>
                  <div
                    style={{
                      color: "#402E46",
                      opacity: 0.7,
                      width: "80px",
                      textAlign: "center",
                    }}
                  >
                    Average Words
                  </div>
                </div> 



                {/* Disabled Groups */}
                {/* <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ fontSize: "50px" }}>
                    {caseData.total_groups}
                  </div>
                  <div
                    style={{
                      color: "#402E46",
                      opacity: 0.7,
                      width: "80px",
                      textAlign: "center",
                    }}
                  >
                    Total Groups
                  </div>
                </div> */}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ fontSize: "50px" }}>
                    {caseData.average_pages}
                  </div>
                  <div
                    style={{
                      color: "#402E46",
                      opacity: 0.7,
                      width: "80px",
                      textAlign: "center",
                    }}
                  >
                    Average Pages
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ fontSize: "50px" }}>
                    {caseData.profanities}
                  </div>
                  <div
                    style={{
                      color: "#402E46",
                      opacity: 0.7,
                      width: "80px",
                      textAlign: "center",
                    }}
                  >
                    Abusive Words
                  </div>
                </div>

              </div>
              </Box>
            </div>
          </div>

          {/* <Grid className="homecrd1 customhpad1" sx={{ width: "100%", minHeight: '120px !important' }}>
            <Grid
              style={{
                fontSize: "20px",
                marginBottom: "40px",
                paddingLeft: "10px",
              }}
            >
              Sentiment Details
            </Grid>
            <Grid container>
              <Grid md={9} lg={9} sm={12} xs={12}>
                <Grid container sx={{ display: 'flex', flexDirection: 'column', gap: '12px', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                  <div
                    style={
                      caseData.sentiment_label == "positive"
                        ? {
                            color: "#14804A",
                            fontSize: 'xx-large',
                            backgroundColor: "#bdffde",
                            textAlign: "center",
                            borderRadius: 20,
                            textTransform: "capitalize",
                            padding: '5px 10px',
                            width: 'fit-content'
                          }
                        : 
                          caseData.sentiment_label == 'negative' ?
                            {
                              color: "#a90202",
                              fontSize: 'xx-large',
                              backgroundColor: "#ffd0d0",
                              textAlign: "center",
                              borderRadius: 20,
                              padding: '5px 10px',
                              textTransform: "capitalize",
                              width: 'fit-content'
                            }
                          :
                            {
                              color: 'darkslategray',
                              fontSize: 'xx-large',
                              backgroundColor: "lightgray",
                              textAlign: "center",
                              borderRadius: 20,
                              padding: '5px 10px',
                              textTransform: "capitalize",
                              width: 'fit-content'
                            }
                    }
                  >
                    {caseData.sentiment_label}
                  </div> */}
                  {/* {Math.sign(caseData.sentiment_score) == "+1" ? ( */}
                  {/*   <Grid md={6} lg={6} sm={6} xs={6}> */}
                  {/*     <DonutChart */}
                  {/*       data={[ */}
                  {/*         caseData.sentiment_score.toFixed(1) * 50 - 100, */}
                  {/*         caseData.sentiment_score.toFixed(1) * 50, */}
                  {/*       ]} */}
                  {/*       colors={["#c9f3de", "#14804A"]} */}
                  {/*       text={ */}
                  {/*         caseData.sentiment_score.toFixed(1) == "0.0" */}
                  {/*           ? ` ${caseData.sentiment_score.toFixed(1)}` */}
                  {/*           : `+${caseData.sentiment_score.toFixed(1)}` */}
                  {/*       } */}
                  {/*       textColor="#14804A" */}
                  {/*     /> */}
                  {/*   </Grid> */}
                  {/* ) : ( */}
                  {/*   <Grid md={6} lg={6} sm={6} xs={6}> */}
                  {/*     <DonutChart */}
                  {/*       data={[ */}
                  {/*         caseData.sentiment_score.toFixed(1) * 50 * -1 - 100, */}
                  {/*         caseData.sentiment_score.toFixed(1) * 50 * -1, */}
                  {/*       ]} */}
                  {/*       colors={["#edc7d0", "#D12953"]} */}
                  {/*       text={`${caseData.sentiment_score.toFixed(1)}`} */}
                  {/*       textColor="#D12953" */}
                  {/*     /> */}
                  {/*   </Grid> */}
                  {/* )} */}
                  {/*}
                </Grid>
              </Grid>
              <Grid md={3} lg={3} sm={12} xs={12}>
                <Grid container>
                  <Grid md={12} lg={12} sm={6} xs={6} className="hmchrtinfo">
                    <h1>{caseData.profanities}</h1>
                    <p>
                      Abusive <br /> Words
                    </p>
                  </Grid>
                  <Grid md={12} lg={12} sm={6} xs={6} className="hmchrtinfo">
                    <h1>{caseData.total_documents}</h1>
                    <p>
                      Total <br /> documents
                    </p>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid> */}

          <Grid style={{ marginTop: 30, width: "100%", paddingRight: "20px" }}>
            { docLoading ?
                <Box sx={{ display: 'flex', justifyContent:'center', width: '100%'}}>
                {/* <CircularProgress /> */}
                <CircularProgress 
                  style={{
                    display: 'flex',
                    justifyContent: 'center'
                    // textAlign: "center",
                    // marginTop: "10%",
                    // lineHeight: 2,
                    // fontWeight: "100",
                  }} 
                />
              </Box>
            :
                <DocumentTable
                    rowData={rowData}
                    totalRows={caseData.total_documents}
                    getPage={setPage}
                    setPage={setPage}
                    currentPage={page}
                    totalPages={totalPages}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    fetchCases={fetchCases}
                    setFilters={setFilters}
                    filters={filters}
                    totalItems={totalItems}
                />
            }
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default CaseDetails;
